module.exports = __webpack_public_path__ + "assets/img/tiger1.465475b7.jpg";